var map = {
	"./caigou.svg": "c/oq",
	"./caiwuxitong.svg": "MHXI",
	"./dianziyouxiang.svg": "hAWA",
	"./huanyingruzhu.svg": "l68c",
	"./oa.svg": "Uq9A",
	"./renshidangan.svg": "LLfy",
	"./tushuguan.svg": "Df3W",
	"./wangluo.svg": "Q0Ny",
	"./xin.svg": "ecgJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 14